var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M6.53 14.53a.75.75 0 01-1.06-1.06l6-6c.3-.3.77-.3 1.06 0l6 6a.75.75 0 01-1.06 1.06L12 9.06l-5.47 5.47z"}})}
var staticRenderFns = []

export { render, staticRenderFns }